import React from "react";
import { Row, Col } from "reactstrap";
import { TIMEOUT } from "UTILS/Constants";
import { getMessage } from "CONFIG/i18n";
import { ToastContainer, toast, Slide } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import infoIcon from "ASSETS/Images/ic_info.svg"
import errorIcon from "ASSETS/Images/ic_error_toastr.svg"
import successIcon from "ASSETS/Images/ic_success.svg"

import "./tostr.less";

class ShowTostr extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      offline: false,
    }
  }

  componentDidMount() {
    window.addEventListener('offline', () => { this.setState({offline: true}) });
    window.addEventListener('online', () => { this.setState({offline: false}) });
  }

  componentDidUpdate(prevProps, prevState){
    if(prevState.offline !== this.state.offline && this.state.offline === true){
      toast.dismiss()
      this.constructor.error(getMessage("NETWORK_ERROR"));
    }
    if(prevState.offline !== this.state.offline && this.state.offline === false){
      toast.dismiss()
      this.constructor.success(getMessage("YOU_ARE_ONLINE"), {timeOut: TIMEOUT.SHORT});
    }
  }

  componentWillUnmount() {
    toast.dismiss();
  }

  static info(message, toastOptions) {
    const infoMessageBody = (
      <div className="d-flex flex-row align-items-center">
        <img src={infoIcon} className="pr-2"/>
        <span className="toasterText">{message}</span>
      </div>
    );
    
    toast.info(infoMessageBody, toastOptions);
  }

  static infoMassageList(messageList, toastOptions) {
    const infoMessageBody = (
      <div className="d-flex flex-row align-items-center">
        <Col className="infoMassageListIcon">
          <img src={infoIcon} className="pr-2"/>
        </Col>
        <Col>
          { messageList.map((message) => {
            return (
              <Row>
                <span className="toasterText">{message}</span>
              </Row>
            );
          })}
        </Col>
      </div>
    );

    toast.info(infoMessageBody, toastOptions);
  }

  static error(message, toastOptions) {
    const errorMessageBody = (
      <div className="d-flex flex-row align-items-center">
        {navigator.onLine && <img src={errorIcon} className="pr-2"/>}
        <span className="toasterText">{message}</span>
      </div>
    );
    
    toast.error(errorMessageBody,toastOptions);
  }
      
  static success(message, toastOptions){
    const successMessageBody = (
      <div className="d-flex flex-row align-items-center">
        <img src={successIcon} className="pr-2"/>
        <span className="toasterText">{message}</span>
      </div>
    );
    
    toast.success(successMessageBody,toastOptions);
  }

  render() {
    return (
      <div>
        <ToastContainer
          position="bottom-right"
          transition={Slide}
          autoClose={TIMEOUT.SHORT}
          hideProgressBar={true}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss={false}
          draggable={false}
          pauseOnHover
          delay={1000}
        />
      </div>
    );
  }
}

export default ShowTostr;
